import { Switch } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import PlusIcon from 'components/icons/PlusIcon'
import React, { createContext, Fragment, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LeftArrow from '../../../../components/icons/LeftArrow'
import ShortlistIcon from '../../../../components/icons/Shortlist'
import SuccessIcon from '../../../../components/icons/SubmitCloseIcon'
import CloseRoleDrawer from '../../../../components/UIComponents/CloseRolePopup'
import SucessfullPopup from '../../../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import ToggleThreeOptions from '../../../../components/UIComponents/Toggle/ToggleThreeOptions'
import { RERightArrowIcon, SetRoleDiv, SetRoleHeader } from '../Dashboard/style'
import {
  convertToNumber,
  formatCTC,
  formatNumber,
  formatWithHyphens,
  getPlacedStatus,
  jobCategoryData,
  jobCategoryFilterData,
} from '../RuleEngineCommonFunction'
import AbsenteeStudentsDrawer from './Drawers/AbsenteeStudentsDrawer'
import ApplicationThreshold from './Drawers/ApplicationThreshold'
import AutoApproveCompanyDrawer from './Drawers/AutoApproveCompanyDrawer'
import CTCDrawer from './Drawers/CTCDrawers'
import MaximumApplicationDrawer from './Drawers/MaximumApplicationDrawer'
import RolesApplyingDrawer from './Drawers/RolesApplyingDrawer'
import TenureDrawer from './Drawers/TenureDrawer'
import {
  ArrowDiv,
  ButtonFooterContainer,
  IconButton,
  LevelBasedTable,
  NoteElement,
  RemoveListContainer,
  RemoveListItem,
  RulesNavigationTitle,
  RulesTitle,
  SpanX,
  StyledAddMoreBtn,
  StyledRow,
  StyledRuleHeader,
  StyledTable,
  StyledTableData,
  StyledTextInput,
  StyleRule,
  SubTypoGraphy,
  TableDiv,
  ToggleButtonContainer,
} from './style'

const maxToShow = 8
export const RuleContext = createContext()

function RulesCreationTable({
  readOnly = false,
  ruleForm,
  setState,
  state,
  getCorporateList,
  degreeStreamList,
  setBrandList,
  brandList,
  setIsOpen,
  isOpen,
  handleSpecificSwitchChange,
  rulesDetails,
  selectedObj = {},
  handleRemove,
  handleSubmit,
  ruleDate,
  fetchInstituteRulesById,
  ruleId,
  getListOfCompanies,
  setSuccessRulePopup,
  successRulePopup,
  loading,
  handleBackApplyClick,
}) {
  const degreeStreamListToRender =
    degreeStreamList || rulesDetails?.degreeStreamMapId
  const [selectedRuleDrawer, setSelectedRuleDrawer] = useState({})
  const isEnabled = state
    ? state.ctcRule.isEnabled ||
      state.internship.isEnabled ||
      state.gigs.isEnabled ||
      state.apprenticeship.isEnabled ||
      state.maxRolesAllowed.isEnabled ||
      state.roleApplyPermit.isEnabled ||
      state.absentCount.isEnabled ||
      state.applicationStatusThreshold.isEnabled ||
      state.brands.isEnabled
    : false

  const [changeTabStatus, setChangeTabStatus] = useState('PLACEMENT')

  const [isExpanded, setIsExpanded] = useState(false)
  const [saveRulePopup, setSaveRulePopup] = useState(false)

  const memoizedValue = useMemo(
    () => ({
      state,
      setState,
      ruleForm,
      selectedRuleDrawer,
      getCorporateList,
      brandList,
      setBrandList,
      getListOfCompanies,
    }),
    [
      state,
      setState,
      ruleForm,
      selectedRuleDrawer,
      getCorporateList,
      brandList,
      setBrandList,
      getListOfCompanies,
    ]
  )

  const footer = () => {
    let disabled = false
    const { type } = selectedRuleDrawer
    if (type === 'internship' || type === 'gigs' || type === 'apprenticeship') {
      let tenureRange = ruleForm.getFieldValue([type, 'tenureRange'])

      disabled = !tenureRange.some(
        item => item.isEnabled && item.endMonth && item.startMonth
      )
    }
    if (type === 'brands') {
      disabled = brandList.length === 0
    }
    return (
      <ButtonFooterContainer justify={'end'}>
        <Button.Secondary
          text="Apply"
          style={{ width: '100px', marginRight: '15px' }}
          disabled={disabled}
          onClick={async () => {
            try {
              await ruleForm.validateFields()
              renderSelectedDrawer(true)
              ruleForm.submit()
            } catch (err) {
              //
            }
          }}
        />
      </ButtonFooterContainer>
    )
  }

  const content = () => {
    return (
      <RuleContext.Provider value={memoizedValue}>
        {renderSelectedDrawer()}
      </RuleContext.Provider>
    )
  }

  const isEnabledChanges = (fieldName, value) => {
    setState(prevState => ({
      ...prevState,
      [fieldName]: {
        ...prevState[fieldName],
        isEnabled: value,
      },
    }))
  }

  const renderSelectedDrawer = (isEnabled = false) => {
    if (selectedRuleDrawer?.value === 6) {
      if (isEnabled) {
        isEnabledChanges('applicationStatusThreshold', true)
      } else {
        return <ApplicationThreshold />
      }
    } else if (selectedRuleDrawer?.value === 1) {
      if (isEnabled) {
        isEnabledChanges('ctcRule', true)
      } else {
        return <CTCDrawer />
      }
    } else if (selectedRuleDrawer?.value === 2) {
      if (isEnabled) {
        isEnabledChanges('brands', state.brands?.brandsList?.length > 0)
      } else {
        return <AutoApproveCompanyDrawer />
      }
    } else if (selectedRuleDrawer?.value === 3) {
      if (isEnabled) {
        isEnabledChanges('roleApplyPermit', true)
      } else {
        return <RolesApplyingDrawer />
      }
    } else if (selectedRuleDrawer?.value === 5) {
      if (isEnabled) {
        isEnabledChanges('absentCount', true)
      } else {
        return <AbsenteeStudentsDrawer />
      }
    } else if (selectedRuleDrawer?.value === 4) {
      if (isEnabled) {
        isEnabledChanges('maxRolesAllowed', true)
      } else {
        return <MaximumApplicationDrawer />
      }
    } else if (selectedRuleDrawer?.value === 7) {
      if (isEnabled) {
        if (changeTabStatus === 'INTERNSHIP') {
          isEnabledChanges('internship', true)
        } else if (changeTabStatus === 'APPRENTICESHIP') {
          isEnabledChanges('apprenticeship', true)
        } else if (changeTabStatus === 'GIGS') {
          isEnabledChanges('gigs', true)
        }
      } else {
        return <TenureDrawer />
      }
    }
  }
  const handleDrawerClose = async () => {
    await fetchInstituteRulesById(ruleId, false, true)
    setIsOpen(false)
    setTimeout(() => {
      setSelectedRuleDrawer({})
    }, 500)
  }

  const renderApproveCompany = () => {
    const { brands } = rulesDetails

    return (
      <div className="companyList">
        {Array.isArray(brands?.list) &&
          brands?.list
            .slice(0, isExpanded ? brands?.list.length : maxToShow)
            .map((company, index, array) => (
              <React.Fragment key={index + 'companyList'}>
                {company?.corporateName}
                {index < array.length - 1 && ', '}
              </React.Fragment>
            ))}

        {brands?.list?.length > maxToShow && (
          <button className="showBtn" onClick={toggleShowMore}>
            {isExpanded ? 'Show Less' : `Show More`}
          </button>
        )}
      </div>
    )
  }

  const renderApplicationThreshold = () => {
    const { applicationStatusThreshold } = rulesDetails || {}
    const {
      ctcThreshold,
      placementType,
      placedLimit,
      compensationThreshold,
      offerEnabled,
      exceptionBrands,
    } = applicationStatusThreshold || {}

    return (
      <div>
        <div>
          {ctcThreshold?.minThreshold > 0 && (
            <div style={{ paddingBottom: 10 }}>
              Minimum Threshold -{' '}
              <b style={{ color: '#2563EB' }}>
                {formatCTC(ctcThreshold?.minThreshold || 0)}
              </b>
            </div>
          )}

          {placementType?.length > 0 && (
            <div>
              No. of &nbsp; <b> {getPlacedStatus(placementType[0])}</b> a
              student can hold -{' '}
              <b style={{ color: '#2563EB' }}>{placedLimit}</b>
            </div>
          )}
          {ctcThreshold?.isMultiples && ctcThreshold?.multiplesThreshold && (
            <div>
              Thresholds -{' '}
              <b style={{ color: '#2563EB' }}>
                {ctcThreshold?.multiplesThreshold} X
              </b>
            </div>
          )}
          {ctcThreshold?.isAbsolute && ctcThreshold?.absoluteThreshold && (
            <div>
              Thresholds -{' '}
              <b style={{ color: '#2563EB' }}>
                {formatCTC(ctcThreshold?.absoluteThreshold, true) || ''}
              </b>
            </div>
          )}
        </div>
        {compensationThreshold?.isEnabled ? (
          <LevelBasedTable className="tableItem" style={{ width: '100%' }}>
            <tbody>
              {compensationThreshold?.compensationList
                ?.filter(f => f.name && f.minCTC)
                ?.map((tableItem, index) => {
                  return (
                    <tr key={index + tableItem?.orderNo}>
                      <td
                        style={{
                          width: '30%',
                          paddingLeft: 15,
                          paddingRight: 10,
                        }}
                      >
                        {tableItem.name}
                      </td>
                      <td
                        style={{
                          width: '20%',
                          borderRight: 'none',
                          paddingLeft: 15,
                        }}
                      >
                        <span className="tableData_text">
                          {formatNumber(tableItem.minCTC)}
                        </span>
                      </td>
                      <td
                        style={{
                          borderLeft: 'none',
                          borderRight: 'none',
                          fontWeight: 700,
                        }}
                      >
                        {tableItem.maxCTC ? '-' : '+'}
                      </td>
                      <td style={{ borderLeft: 'none' }}>
                        <span className="tableData_text">
                          {tableItem.maxCTC
                            ? formatNumber(tableItem.maxCTC)
                            : ''}
                        </span>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </LevelBasedTable>
        ) : null}
        <div>
          {typeof offerEnabled === 'boolean' && (
            <div style={{ fontSize: '16px', marginTop: '20px' }}>
              <b>
                {offerEnabled ? 'Allow' : "Don't allow"} students to apply for
                higher hierarchy
              </b>
            </div>
          )}
          {exceptionBrands?.list?.length > 0 ? (
            <div
              className="companyList"
              style={{
                color: '#3249D7',
                fontWeight: 500,
                marginTop: 20,
                textTransform: 'capitalize',
              }}
            >
              <div style={{ color: '#000000' }}>Exception Brands</div>
              {Array.isArray(exceptionBrands?.list) &&
                exceptionBrands?.list
                  .slice(
                    0,
                    isExpanded ? exceptionBrands?.list.length : maxToShow
                  )
                  .map((company, index, array) => (
                    <>
                      {company?.corporateName?.toLowerCase()}
                      {index < array.length - 1 && ', '}
                    </>
                  ))}

              {exceptionBrands?.list?.length > maxToShow && (
                <button className="showBtn" onClick={toggleShowMore}>
                  {isExpanded ? 'Show Less' : `Show More`}
                </button>
              )}
            </div>
          ) : null}
        </div>
      </div>
    )
  }

  const handleRuleDrawerClick = data => {
    if (!readOnly) {
      setSelectedRuleDrawer(data)
      setIsOpen(true)
    }
  }

  const renderJobDetails = jobCategory => {
    if (!rulesDetails?.jobCategory) return ''

    const { duration, tenureRange } =
      rulesDetails.jobCategory[jobCategory] || {}
    let text
    if (jobCategory === 'internship') {
      text = 'Internship'
    } else if (jobCategory === 'apprenticeship') {
      text = 'Apprenticeship'
    } else {
      text = 'Gigs'
    }

    if (duration) {
      return (
        <div style={{ fontWeight: 500 }}>
          {text} duration set to
          <b style={{ color: '#3249D7' }}> {duration} months </b>
          {tenureRange
            ?.filter(item => item.isEnabled)
            .map((item, index) => (
              <div key={index + item.startMonth}>
                From <b style={{ color: '#3249D7' }}> {item.startMonth} </b> to{' '}
                <b style={{ color: '#3249D7' }}> {item.endMonth}</b>
              </div>
            ))}
        </div>
      )
    } else {
      return ''
    }
  }

  const tableData = [
    {
      title: 'Auto approvals for PIL roles',
      category: 'PLACEMENT',
      tableContent: [
        {
          title: 'CTC Threshold',
          drawerTitle: 'CTC Threshold',
          description:
            'This CTC threshold is specifically applicable to PIL corporates who are posting the job role. All roles floated by PIL corporates adhere to this CTC requirement.',
          details:
            convertToNumber(rulesDetails?.ctcRule?.compensation) > 0
              ? `<b style="font-weight:500">Minimum Threshold - </b> <b style="color:#2563EB;font-weight:700;"> ${formatCTC(
                  rulesDetails?.ctcRule?.compensation
                )} </b> <br/>  ${
                  rulesDetails?.ctcRule?.allowClosestCTC
                    ? `<b style="font-weight:500">Allow closest CTC up to <b> - <b style="color:#2563EB;font-weight:700;"> ${rulesDetails?.ctcRule?.closestCtcRate}% </b>`
                    : ''
                }`
              : '',
          status: state?.ctcRule?.isEnabled,
          value: 1,
          width: '600px',
          type: 'ctcRule',
          checkStatus: !rulesDetails?.ctcRule?.compensation,
        },
        {
          title: 'Approve Company',
          drawerTitle: 'Auto Approve Company',
          description:
            'The Companies set here is specifically applicable to PIL corporates who are posting the job role. This will override the CTC threshold that is set above.',
          details: '',
          status: state?.brands?.isEnabled,
          renderDetails: renderApproveCompany,
          value: 2,
          width: '600px',
          type: 'brands',
          checkStatus: brandList?.length === 0,
        },
      ],
    },
    {
      title: 'Other rules',
      category: 'PLACEMENT',
      tableContent: [
        {
          title: 'Roles applying threshold',
          drawerTitle: 'Roles applying threshold',
          description:
            'Enter the no. of roles a student should apply when the placement process opens up.',
          details: rulesDetails?.roleApplyPermit?.roleCount
            ? `Each student must apply to at least <b style="color:#2563EB;"> ${rulesDetails?.roleApplyPermit?.roleCount} </b> roles.`
            : '',
          status: state?.roleApplyPermit?.isEnabled || false,
          value: 3,
          width: '600px',
          type: 'roleApplyPermit',
          checkStatus: !rulesDetails?.roleApplyPermit?.roleCount,
        },
        {
          title: 'Maximum no. of roles allowed',
          drawerTitle: 'Maximum Applications',
          description: 'Enter the no. of roles a student can apply for.',
          details: rulesDetails?.maxRolesAllowed?.roleCount
            ? `Each student is allowed to apply for a maximum of  <b style="color:#2563EB;"> ${rulesDetails?.maxRolesAllowed?.roleCount} </b> roles.`
            : '',
          status: state?.maxRolesAllowed?.isEnabled || false,
          value: 4,
          width: '600px',
          type: 'maxRolesAllowed',
          checkStatus: !rulesDetails?.maxRolesAllowed?.roleCount,
        },
        {
          title: 'Absent students',
          drawerTitle: 'Absentee Students',
          description:
            'Restricts students from applying for roles if they miss a certain no. of evaluation process rounds',
          details: rulesDetails?.absentCount?.missedEvaluationCount
            ? `Students are restricted after they miss  <b style="color:#2563EB;"> ${rulesDetails?.absentCount?.missedEvaluationCount} </b> evaluation process`
            : '',
          status: state?.absentCount?.isEnabled || false,
          value: 5,
          width: '600px',
          type: 'absentCount',
          checkStatus: !rulesDetails?.absentCount?.missedEvaluationCount,
        },
      ],
    },
    {
      title: 'Application thresholds',
      category: 'PLACEMENT',
      tableContent: [
        {
          title: 'Application status thresholds',
          drawerTitle: 'Application status thresholds',
          description:
            'The student’s application status will decide if the student can keep applying for jobs or not.',
          details: '',
          status: state?.applicationStatusThreshold?.isEnabled || false,
          value: 6,
          renderDetails: renderApplicationThreshold,
          width: '841px',
          type: 'applicationStatusThreshold',
          checkStatus:
            !rulesDetails?.applicationStatusThreshold?.placementType?.length >
            0,
        },
      ],
    },
    {
      category: 'INTERNSHIP',
      tableContent: [
        {
          title: 'Tenure',
          drawerTitle: 'Tenure',
          description:
            'This rule determines the number of months of internship that the college permits students to undertake and specifies the periods of the year during which these internships can occur.',
          details: '',
          status: state?.internship?.isEnabled,
          value: 7,
          category: 'internship',
          width: '600px',
          type: 'internship',
          renderDetails: () => renderJobDetails('internship'),
          checkStatus:
            !rulesDetails?.jobCategory?.internship?.tenureRange?.some(
              item => item?.isEnabled
            ),
        },
      ],
    },
    {
      category: 'APPRENTICESHIP',
      tableContent: [
        {
          title: 'Tenure',
          drawerTitle: 'Tenure',
          description:
            'This rule determines the number of months of Apprenticeship that the college permits students to undertake and specifies the periods of the year during which these internships can occur.',
          details: '',
          status: state?.apprenticeship?.isEnabled,
          value: 7,
          category: 'apprenticeship',
          width: '600px',
          type: 'apprenticeship',
          renderDetails: () => renderJobDetails('apprenticeship'),
          checkStatus:
            !rulesDetails?.jobCategory?.apprenticeship?.tenureRange?.some(
              item => item?.isEnabled
            ),
        },
      ],
    },
    {
      category: 'GIGS',
      tableContent: [
        {
          title: 'Tenure',
          drawerTitle: 'Tenure',
          description:
            'This rule determines the number of months of Gigs that the college permits students to undertake and specifies the periods of the year during which these internships can occur.',
          details: '',
          status: state?.gigs?.isEnabled,
          value: 7,
          category: 'gigs',
          width: '600px',
          type: 'gigs',
          renderDetails: () => renderJobDetails('gigs'),
          checkStatus: !rulesDetails?.jobCategory?.gigs?.tenureRange?.some(
            item => item?.isEnabled
          ),
        },
      ],
    },
  ]

  const toggleShowMore = () => {
    setIsExpanded(!isExpanded)
  }

  const navigate = useNavigate()

  const handleChange = (value, fieldName) => {
    setState(prevState => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const renderDegreeStreamList = list =>
    list.map((item, index) => (
      <RemoveListContainer key={item?.id + index}>
        <RemoveListItem
          enabled
          selected={selectedObj?.degreeStreamMapId === item?.id}
          isOverwritten={item?.isOverWritten || false}
        >
          {`${item?.degree?.shortForm} - ${item?.stream?.name}`}
        </RemoveListItem>
        {!readOnly && (
          <SpanX
            onClick={() => handleRemove(item?.id)}
            isOverwritten={item?.isOverWritten || false}
          >
            x
          </SpanX>
        )}
      </RemoveListContainer>
    ))

  const handleCloseClick = () => {
    setSaveRulePopup(false)
    handleSubmit(1)
  }
  const handleCloseDrawer = () => {
    setSuccessRulePopup(false)
    navigate('/ruleEngine')
  }
  return (
    <Fragment>
      {!readOnly ? (
        <StyledRuleHeader>
          <IconButton>
            <LeftArrow onClick={handleBackApplyClick} />
          </IconButton>
          <RulesNavigationTitle>
            {'Setting new rules'}
            <span className="description">
              This rule set will be effective from (
              {loading ? '' : formatWithHyphens(ruleDate)})
            </span>
          </RulesNavigationTitle>
        </StyledRuleHeader>
      ) : null}

      <div
        style={{
          display: readOnly ? 'flex' : 'block',
          flexDirection: 'column-reverse',
        }}
      >
        <SetRoleDiv enable={false} style={{ marginBottom: 10 }}>
          <SubTypoGraphy>
            {readOnly ? (
              rulesDetails?.ruleName
            ) : (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
              >
                Selected degrees & departments
                {degreeStreamListToRender?.some(
                  item => item?.isOverWritten
                ) && (
                  <div
                    style={{
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    (
                    <div
                      style={{
                        background: '#FF4D00',
                        width: 10,
                        height: 10,
                        borderRadius: 10,
                        margin: 5,
                        marginTop: 7,
                      }}
                    ></div>
                    Rules getting overridden )
                  </div>
                )}
              </div>
            )}
          </SubTypoGraphy>
          <div style={{ marginBottom: 15, marginTop: 8 }}>
            {renderDegreeStreamList(degreeStreamListToRender)}
          </div>
        </SetRoleDiv>

        {!readOnly && (
          <>
            <StyledAddMoreBtn
              icon={<PlusIcon color={'rgba(37, 99, 235, 1)'} />}
              text={'Add More'}
              fontsize={'13px'}
              onClick={handleBackApplyClick}
            />
            <StyleRule>
              <SetRoleDiv RuleSetStyle>Rule Set Name</SetRoleDiv>
              <StyledTextInput
                InputStyle
                type="text"
                placeholder="Rule Set 1"
                height={'48px'}
                width={'284px'}
                onChange={e => handleChange(e.target.value, 'ruleName')}
                value={state.ruleName}
              />
            </StyleRule>{' '}
            <SetRoleHeader flexstart enable Style>
              Set up rules for all these processes for the selected Degree &
              Departments.
            </SetRoleHeader>
          </>
        )}

        <ToggleThreeOptions
          tabs={jobCategoryFilterData(jobCategoryData) ?? []}
          current={changeTabStatus}
          handleClick={e => setChangeTabStatus(e.value)}
          normalTextColor={'#000000'}
        />
      </div>

      {!readOnly && (
        <>
          <NoteElement topSpacing={7}>
            Edit, Activate/Deactivate Rules here
          </NoteElement>
          <NoteElement warning>
            Note : Students who meet the eligibility criteria but are restricted
            by the rule engine can request approval to apply for the role.
          </NoteElement>
        </>
      )}

      <TableDiv>
        <StyledTable style>
          <tr className="head">
            <th>Rule</th>
            <th>Details</th>
            <th>Status</th>
          </tr>

          {tableData
            ?.filter(data => data?.category === changeTabStatus)
            .map((item, index) => {
              return (
                <React.Fragment key={index + item?.title}>
                  {item?.title ? (
                    <tr className="odd-row">
                      <td>{item?.title}</td>
                    </tr>
                  ) : null}

                  {item?.tableContent?.map((tableValue, idx) => (
                    <StyledRow
                      key={idx + tableValue?.title}
                      borderTop={idx === 0}
                      borderBottom={idx === item?.tableContent?.length - 1}
                    >
                      <StyledTableData
                        className={tableValue?.title.split(/\s+/).join('')}
                        firstData={idx === 0}
                        lastData={idx === item?.tableContent?.length - 1}
                      >
                        <ArrowDiv
                          onClick={() => handleRuleDrawerClick(tableValue)}
                        >
                          <RulesTitle readOnly={readOnly} isPopup={isOpen}>
                            {tableValue?.title}
                            {!readOnly && (
                              <RERightArrowIcon readOnly={readOnly} />
                            )}
                          </RulesTitle>
                        </ArrowDiv>
                        <p>{tableValue?.description}</p>
                      </StyledTableData>
                      <StyledTableData
                        firstData={idx === 0}
                        lastData={idx === item?.tableContent?.length - 1}
                      >
                        {tableValue?.renderDetails ? (
                          tableValue?.renderDetails()
                        ) : (
                          <div>
                            <p
                              className="tableDetails"
                              dangerouslySetInnerHTML={{
                                __html: tableValue?.details,
                              }}
                            />
                          </div>
                        )}
                      </StyledTableData>
                      <StyledTableData
                        firstData={idx === 0}
                        lastData={idx === item?.tableContent?.length - 1}
                      >
                        <ToggleButtonContainer>
                          <Switch
                            key={idx + tableValue?.title}
                            checked={tableValue?.status}
                            disabled={tableValue?.checkStatus || readOnly}
                            onChange={checked =>
                              handleSpecificSwitchChange(
                                checked,
                                tableValue?.type
                              )
                            }
                          />
                        </ToggleButtonContainer>
                      </StyledTableData>
                    </StyledRow>
                  ))}
                </React.Fragment>
              )
            })}
          {!readOnly && (
            <tr>
              <td></td>
              <td></td>
              <td
                className="Savebutton"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 40,
                }}
              >
                {rulesDetails?.status !== 1 ? (
                  <Button.Secondary
                    text="Save draft"
                    onClick={() => handleSubmit(0)}
                    disabled={!isEnabled}
                  />
                ) : null}
                <Button.Primary
                  text="Save rules"
                  onClick={() => setSaveRulePopup(true)}
                  disabled={!isEnabled}
                />
              </td>
            </tr>
          )}

          <CloseRoleDrawer
            showDrawer={saveRulePopup}
            setShowDrawer={setSaveRulePopup}
            description={
              <>
                Are you sure you want to{' '}
                {rulesDetails?.status !== 1 ? 'save' : 'set'} this rule?
              </>
            }
            Icon={ShortlistIcon}
            onApprove={handleCloseClick}
            onCloseClick={()=>setSaveRulePopup(false)}
          />
          <SucessfullPopup
            showDrawer={successRulePopup}
            setShowDrawer={setSuccessRulePopup}
            description={
              <>Rule is set to effect from {formatWithHyphens(ruleDate)}</>
            }
            Icon={SuccessIcon}
            handleCloseDrawer={handleCloseDrawer}
          />
        </StyledTable>
      </TableDiv>

      <Drawer
        title={selectedRuleDrawer?.drawerTitle}
        placement="right"
        closable={!readOnly}
        onClose={handleDrawerClose}
        visible={isOpen}
        content={content()}
        footerStyles={true}
        footer={footer()}
        open={isOpen}
        width={selectedRuleDrawer?.width || '841px'}
        overflowBody={selectedRuleDrawer?.value === 2 ? 'hidden' : 'auto'}
      />
    </Fragment>
  )
}

export default RulesCreationTable
